import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { requirePermission } from "../../../../shared/routing/requirePermission";
import { DEVICE_TYPES_VIEW } from "../../devicesPermissions";
import type { DevicesRouteFactory } from "./devicesRouteContext";

const DeviceTypesListScreen = lazyRouteComponent(
  () => import("../DeviceTypesListScreen"),
  "DeviceTypesListScreen",
);

export const createDeviceTypesRoutes: DevicesRouteFactory = ({ context }) => [
  createRoute({
    getParentRoute: context.getParentRoute,
    path: `${context.basePath}/types`,
    beforeLoad: requirePermission([DEVICE_TYPES_VIEW]),
    component: DeviceTypesListScreen,
  }),
];
